const GRID_BOX = {image:"",title:"",type:"",link:""};

const EACH_SECTION = [
        GRID_BOX,
        GRID_BOX,
        GRID_BOX
    ];

const TAB_SECTION = {
    section_heading : "",
    section_row : EACH_SECTION
}

const INITIAL_KNOWLEDGE_CENTER_POPUP = {
    bucket:{
        cleartrail: {
            disable: "no",
            data : [
                // {
                //     tabtitle : "Sessions",
                //     requestdemoname: "",
                //     disable: "",
                //     inner_data : [
                //         TAB_SECTION
                //     ]
                // },
                {
                    tabtitle : "About",
                    requestdemoname: "",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/ClearTrail_Corporate_Profile-1.jpg",title:"About ClearTrail Technologies",type:"brochure",link:"https://community-wp.ciisummit.com/wp-content/uploads/protected-files/ClearTrail_Corporate_Profile.pdf"},
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/Product-Portfolio-Brochure-1.jpg",title:"Product Booklet",type:"brochure",link:"https://community-wp.ciisummit.com/wp-content/uploads/protected-files/ClearTrail_Product_Booklet.pdf"},
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/ClearTrail-Technologies-Introduction-1.jpg",title:"ClearTrail Technologies Introduction",type:"Video",link:"https://player.vimeo.com/video/667685893"}
                            ]
                        }
                    ]
                },  
                {
                    tabtitle : "CARBON",
                    requestdemoname: "Trial",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/carbon-brochuer.jpg",title:"IP Data Decoder and Analyser: Brochure",type:"brochure",link:"https://community-wp.ciisummit.com/wp-content/uploads/protected-files/ClearTrail_CARBON_Brochure.pdf"},
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/carbon-video.jpg",title:"Video",type:"Video",link:"https://player.vimeo.com/video/720547581"}
                            ]
                        }
                    ]
                }, 
                  {
                    tabtitle : "WebTrail",
                    requestdemoname: "Trial ",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/webtrail-Brochure.jpg",title:"Open-Source Intelligence from Social Networks, Surface & Dark Web: Brochure",type:"brochure",link:"https://community-wp.ciisummit.com/wp-content/uploads/protected-files/ClearTrail_WebTrail_Brochure.pdf"},
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/webtrail-White-Paper.jpg",title:"Dark Web Monitoring Guide: White Paper",type:"brochure",link:"https://community-wp.ciisummit.com/wp-content/uploads/protected-files/ClearTrail_Whitepaper_Darkweb.pdf"},
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/webtrail-video.jpg",title:"Video",type:"Video",link:"https://player.vimeo.com/video/688077944"}
                            ]
                        }
                    ]
                }, 
                  {
                    tabtitle : "ComTrail",
                    requestdemoname: "",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/comtrail-Brochure.jpg",title:"Next Generation Monitoring Center for Lawful Interception: Brochure",type:"brochure",link:"https://community-wp.ciisummit.com/wp-content/uploads/protected-files/ClearTrail_ComTrail_Brochure.pdf"}
                            ]
                        }
                    ]
                }, 
                {
                    tabtitle : "ComTrail-NX",
                    requestdemoname: "",
                    disable: "",
                    inner_data : [
                        {
                            section_heading : "",
                            section_row : [
                                {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/comtrail-NX-Brochure.jpg",title:"Massive Telecom Data Mining System: Brochure",type:"brochure",link:"https://community-wp.ciisummit.com/wp-content/uploads/protected-files/ClearTrail_ComTrail-NX.pdf"}
                            ]
                        }
                    ]
                }  
                // {
                //     tabtitle : "Statgrid",
                //     requestdemoname: "",
                //     disable: "",
                //     inner_data : [
                //         {
                //             section_heading : "",
                //             section_row : [
                //                 {image:"https://community-wp.ciisummit.com/wp-content/uploads/2022/09/Statgrid-brochuer.jpg",title:"Statgrid: Concept note",type:"brochure",link:"https://community-wp.ciisummit.com/wp-content/uploads/protected-files/ClearTrail_Concept_Note_Statgrid.pdf"}
                //             ]
                //         }
                //     ]
                // },  
            ]   
        },
        mppolice: {
            
        }
    },
    datatrack: 0
}

const KnowledgeCenterBucket = (state = INITIAL_KNOWLEDGE_CENTER_POPUP, action) => {
    switch(action.type){
        case "SET_KNOWLEDGE_DATA":
            return {
                ...state,
                bucket: action.payload,
                datatrack: 0
            }
        case "SET_KNOWLEDGE_DATATRACK":
            return INITIAL_KNOWLEDGE_CENTER_POPUP
        default:
            return state
    }
}

export default KnowledgeCenterBucket;